/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrentUserDto } from '../models/current-user-dto';
import { getCurrentUser } from '../fn/identity/get-current-user';
import { GetCurrentUser$Params } from '../fn/identity/get-current-user';
import { getCurrentUser$Plain } from '../fn/identity/get-current-user-plain';
import { GetCurrentUser$Plain$Params } from '../fn/identity/get-current-user-plain';

@Injectable({ providedIn: 'root' })
export class IdentityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCurrentUser()` */
  static readonly GetCurrentUserPath = '/api/identity/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUser$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Plain$Response(params?: GetCurrentUser$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentUserDto>> {
    return getCurrentUser$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUser$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Plain(params?: GetCurrentUser$Plain$Params, context?: HttpContext): Observable<CurrentUserDto> {
    return this.getCurrentUser$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentUserDto>): CurrentUserDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Response(params?: GetCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentUserDto>> {
    return getCurrentUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser(params?: GetCurrentUser$Params, context?: HttpContext): Observable<CurrentUserDto> {
    return this.getCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentUserDto>): CurrentUserDto => r.body)
    );
  }

}
